import { render, staticRenderFns } from "./accommodationTypeForm.vue?vue&type=template&id=930412c2"
import script from "./accommodationTypeForm.vue?vue&type=script&lang=js"
export * from "./accommodationTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports